// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1xkY6","productName":"Table_productName__vV0sw"};